import Axios from "axios";

const setLocalID = ({ localID }) => {
    return async (dispatch) => {
        dispatch({ type: "SENSORS_SET_LOCALID", payload: { localID } });
    };
};
const setSensors = ({ configuration }) => {
    return async (dispatch) => {
        dispatch({ type: "SENSORS_SET_MATERIAL", payload: { configuration } });
    };
};
const reset = () => {
    return async (dispatch) => {
        dispatch({ type: "RESET" });
    };
};
const setCustomerID = ({ customerID }) => {
	console.log("entro");
    return async (dispatch) => {
        dispatch({ type: "SENSORS_SET_CUSTOMERID", payload: { customerID } });
    };
};
const setModel = ({ model }) => {
    return async (dispatch) => {
        dispatch({ type: "SENSORS_SET_MODEL", payload: { model } });
    };
};
const setImei = ({ imei }) => {
    return async (dispatch) => {
        dispatch({ type: "SENSORS_SET_IMEI", payload: { imei } });
    };
};

const fetchSensors = () => {
    console.log("FETCH SENSORS")
    return async (dispatch, getState) => {
        try {
            let response = await Axios.get("/adminTool/sensors/locationByID", {
                headers: {
                    authorization: window.localStorage.getItem("token"),
                },
                params: { localID: getState().sensors.localID },
            });
            dispatch({ type: "SENSORS_FETCH", payload: response.data });
        } catch (e) {
            console.log(e);
        }
    };
};

const fetchSensorsFilled = () => {
    console.log("FETCH FILLED")
    return async (dispatch, getState) => {
        try {
            let response = await Axios.get("/adminTool/sensors/filledByID", {
                headers: {
                    authorization: window.localStorage.getItem("token"),
                },
                params: { localID: getState().sensors.localID },
            });
            dispatch({ type: "SENSORS_FETCH_FILLED", payload: response.data });
        } catch (e) {
            console.log(e);
        }
    };
};

const fetchSensorsFilledBySede = ({ customerID }) => {
    console.log("FETCH SEDE")
    return async (dispatch) => {
        try {
            let response = await Axios.get("/adminTool/sensors/filledByIDCustomer", {
                headers: {
                    authorization: window.localStorage.getItem("token"),
                },
                params: { customerID: customerID },
            });
            dispatch({ type: "SENSORS_FETCH_FILLED_SEDE", payload: response.data });
        } catch (e) {
            console.log(e);
        }
    };
};

const sensorsTableByLocal = ({ localID, isAlu, isAln }) => {
    const url = isAlu ? "/adminTool/sensors/sensorsTableByLocal?isAlu=true" : 
                isAln ? "/adminTool/sensors/sensorsTableByLocal?isAln=true" : "/adminTool/sensors/sensorsTableByLocal";
    return async (dispatch) => {
        try {
            let response = await Axios.get(url, {
                headers: {
                    authorization: window.localStorage.getItem("token"),
                },
                params: { localID: localID },
            });
            dispatch({ type: "SENSORS_TABLE_BY_LOCAL", payload: response.data });
        } catch (e) {
            console.log(e);
        }
    };
};

const sensorsTableByImei = ({ imei, isAlu, isAln }) => {
    const url = isAlu ? "/adminTool/sensors/sensorsTableByImei?isAlu=true" : 
                isAln ? "/adminTool/sensors/sensorsTableByImei?isAln=true" : "/adminTool/sensors/sensorsTableByImei";
    return async (dispatch) => {
        try {
            let response = await Axios.get(url, {
                headers: {
                    authorization: window.localStorage.getItem("token"),
                },
                params: { imei: imei },
            });
            console.log("DATA")
            console.log(response.data)
            dispatch({ type: "SENSORS_TABLE_BY_IMEI", payload: response.data });
        } catch (e) {
            console.log("ERROR")
            console.log(e);
        }
    };
};

const sensorsConfigureByLocal = ({ localID }) => {
    console.log("FETCH CONFIGURE")
    return async (dispatch) => {
        try {
            let response = await Axios.get("/adminTool/sensors/sensorsTableByLocal", {
                headers: {
                    authorization: window.localStorage.getItem("token"),
                },
                params: { localID: localID },

            });

            dispatch({ type: "SENSORS_CONFIGURATION_BY_LOCAL", payload: response.data });
        } catch (e) {
            console.log(e);
        }
    };
};

const fetchSensorsLocationByLocal = ({ localID }) => {
    console.log("SENSOR LOCATION LOCAL")
    return async (dispatch) => {
        try {
            let response = await Axios.get("/adminTool/sensors/sensorsLocationByLocal", {
                headers: {
                    authorization: window.localStorage.getItem("token"),
                },
                params: { localID: localID },
            });
            dispatch({ type: "SENSORS_LOCATION_BY_LOCAL", payload: response.data });
        } catch (e) {
            console.log(e);
        }
    };
};

const fetchSensorsLocationBySede = ({ customerID }) => {
    console.log("SENSOR LOCATION SEDE")
    return async (dispatch) => {
        try {
            let response = await Axios.get("/adminTool/sensors/sensorsLocationBySede", {
                headers: {
                    authorization: window.localStorage.getItem("token"),
                },
                params: { customerID: customerID },
            });
            dispatch({ type: "SENSORS_LOCATION_BY_SEDE", payload: response.data });
        } catch (e) {
            console.log(e);
        }
    };
};

const putSensorState = ({ sensorID }) => {
    return async (dispatch) => {
        try {
            let response = await Axios.get("/adminTool/sensors/stateSensorByID", {
                headers: {
                    authorization: window.localStorage.getItem("token"),
                },
                params: { _id: sensorID, }
            });
            dispatch({ type: "SENSORSTATE_REFUSE", payload: response.data });
        } catch (e) {
            console.log(e);
        }
    };
};


const sensorsTableBySede = ({ customerID, isAlu, isAln }) => {
    console.log("SENSOR TABLE SEDE")
    const url = isAlu ? "/adminTool/sensors/sensorsTableBySede?isAlu=true" : 
                isAln ? "/adminTool/sensors/sensorsTableBySede?isAln=true" : "/adminTool/sensors/sensorsTableBySede";
    return async (dispatch) => {
		console.log("entro3");
        try {
            let response = await Axios.get(url, {
                headers: {
                    authorization: window.localStorage.getItem("token"),
                },
                params: { customerID: customerID },
            });
            dispatch({ type: "SENSORS_TABLE_BY_SEDE", payload: response.data });
        } catch (e) {
            console.log(e);
        }
    };
};

const sensorsTableByFill = ({ fill }) => {
    console.log("SENSOR TABLE FILL")
    return async (dispatch) => {
        try {
            let response = await Axios.get("/adminTool/sensors/sensorsTableByFill", {
                headers: {
                    authorization: window.localStorage.getItem("token"),
                },
                params: { fill: fill },
            });
            dispatch({ type: "SENSORS_TABLE_BY_FILL", payload: response.data });
        } catch (e) {
            console.log(e);
        }
    };
};

const sensorsTableByModel = ({ model }) => {
    console.log("SENSOR TABLE MODEL")
    return async (dispatch) => {
        try {
            let response = await Axios.get("/adminTool/sensors/sensorsTableByModel", {
                headers: {
                    authorization: window.localStorage.getItem("token"),
                },
                params: { model: model },
            });
            dispatch({ type: "SENSORS_TABLE_BY_MODEL", payload: response.data });
        } catch (e) {
            console.log(e);
        }
    };
};

export default {

    fetchSensors,
    fetchSensorsFilled,
    fetchSensorsLocationBySede,
    fetchSensorsLocationByLocal,
    setLocalID,
    fetchSensorsFilledBySede,
    setCustomerID,
    sensorsTableByLocal,
    sensorsTableByImei,
    sensorsTableBySede,
    sensorsTableByFill,
    sensorsTableByModel,
    setModel,
    setImei,
    reset,
    setSensors,
    putSensorState,
    sensorsConfigureByLocal,
};
